import R2Image from '@/components/ui/R2Image';
import React from 'react';

interface FloatingImageProps {
  path: string;
  alt: string;
  sizes: string;
  wrapperStyle: React.CSSProperties;
  offsetX: number;
  offsetY: number;
  borderRadius?: string;
  className?: string;
}

const FloatingImage: React.FC<FloatingImageProps> = ({
  path,
  alt,
  sizes,
  wrapperStyle,
  offsetX,
  offsetY,
  borderRadius = '100px',
  className = '',
}) => (
  <div style={{ position: 'relative', ...wrapperStyle }}>
    <div
      aria-hidden="true"
      className="border-theme-primary pointer-events-none absolute inset-0 z-0 border"
      style={{
        borderRadius,
        transform: `translate(${offsetX}px, ${offsetY}px)`,
      }}
    />

    <div
      className="relative z-10 h-full w-full overflow-hidden"
      style={{ borderRadius }}
    >
      <R2Image
        path={path}
        alt={alt}
        sizes={sizes}
        containerClassName="relative h-full w-full"
        className={`h-full w-full object-cover ${className}`}
      />
    </div>
  </div>
);

export default FloatingImage;
